import $ from "cash-dom"

export default () => {
  const three_weeks_ago =
    // the ruby time doesn't contain miliseconds
    Math.floor((new Date().getTime() - 3 * 7 * 24 * 60 * 60 * 1000) / 1000)

  $(".contentbox [data-published-at]").each(function() {
    const published_at = $(this).data("published-at")
    if (!published_at) return
    if (published_at < three_weeks_ago) return
    return $(this).prepend(
      `<div class='contentbox__new_${window.gon.locale}'></div>`
    )
  })
}
